var avatarSize = 'var(--j8elnb0)';
var initialFontSize = 'var(--j8elnb2)';

export { avatarSize, initialFontSize };
//# sourceMappingURL=avatar-base.vars.css.js.map
